import React, { useContext } from 'react'
import CustomButton from './CustomButton'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import '../components/PageNotFound.scss';
import { ReactComponent as RalvieIcon } from "../assets/subscription/ralvieIcon.svg"
import AppContext from '../config/AppContext';

const PageNotFound = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { mode } = useContext(AppContext);
    return (
        <div className='page-not-found-main'>
            <div className='page-not-found-content'>
                <div className='page-not-found-image'>
                    <span
                        style={{
                            marginRight:"30px",
                            color: mode === "dark" ? "#f8f8f8cc" : "#242424",
                        }}
                    >4</span>
                    <RalvieIcon />
                    <span
                        style={{
                            marginLeft:"30px",
                            color: mode === "dark" ? "#f8f8f8cc" : "#242424",
                        }}
                    >4</span>
                </div>

                <Typography className='page-not-found-message'>{t("RAL0847")}</Typography>

                <div className='page-not-found-button'>
                    <CustomButton
                        variant={"contained"}
                        class="memberButton"
                        id="btn-back-to-home"
                        name="btn-back-to-home"
                        onClick={() => navigate("/dashboard")}
                    >
                        {t("RAL0846")}
                    </CustomButton>
                </div>

            </div>

        </div>
    )
}

export default PageNotFound
